import React, { FC } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Tooltip } from '@mui/material';
import { SCUICustomDataGrid } from '../../../../../atomic/molecules';
import TimeHelper from '../../../../../utils/time';
import Helper from '../../../../../utils/helper';
import { useTranslation } from 'react-i18next';

export const SCUIRefundDetailPaymentInfo: FC<{
    getRefundInfo?: any;
    currencySymbol?: any;
}> = ({ getRefundInfo, currencySymbol }) => {
    const datas = getRefundInfo.refund.details && getRefundInfo.refund.details;
    const { t } = useTranslation();

    const columns: ExtendedGridColDef[] = [
        { field: 'refundDetailId', headerName: 'Odeme Id', width: 100 },
        { field: 'referenceId', headerName: 'Reference No', width: 150 },
        { field: 'authCode', headerName: 'Auth Code', width: 150 },
        { field: 'transactionId', headerName: 'Transaction Id', flex: 1 },
        {
            field: 'creditCardRefundMethodName',
            headerName: 'K. K. İade Metodu',
            flex: 1,
        },
        {
            field: 'description',
            headerName: t('general.description'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.description}</h1>}>
                        <div>{params.row.description}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'amountRefunded',
            headerName: t('general.cost'),
            width: 100,
            renderCell: (params) => {
                return (
                    <div>
                        {Helper.formatNumber(params.row.amountRefunded)} {currencySymbol}
                    </div>
                );
            },
        },
        {
            field: 'dateRefunded',
            headerName: 'Ödeme Tarihi',
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHourSecond(params.row.dateRefunded)}</div>;
            },
        },
        { field: 'statusName', headerName: 'Durum', flex: 1 },
    ];

    return (
        <React.Fragment>
            <SCUICustomDataGrid randomId rows={datas} columns={columns} />
        </React.Fragment>
    );
};
